<template>
  <div>
    <Header />
    <main>
      <p>Project landing</p>
      <ul>
        <li>
          <router-link :to="{ name: 'project', params: { id: 1 } }"
            >IA</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'project', params: { id: 2 } }"
            >map2</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'project', params: { id: 4 } }"
            >dmles</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'project', params: { id: 3 } }"
            >zocdoc</router-link
          >
        </li>
      </ul>
    </main>
  </div>
</template>

<script>
import Header from '../components/Header';

export default {
  name: 'Project',
  components: {
    Header
  }
};
</script>

<style scoped lang="scss">
@import '../assets/css/app';

main {
  background: url('../assets/img/background.png') repeat;
  padding: 7rem 2rem 3rem;
  height: 800px;
}
</style>
